import { render } from "./WelcomeParticipant.vue?vue&type=template&id=461ad712&lang=true"
import script from "./WelcomeParticipant.vue?vue&type=script&lang=js"
export * from "./WelcomeParticipant.vue?vue&type=script&lang=js"
script.render = render

export default script